import { Component } from '@angular/core';
import { AutoCompleteComponent } from '@components/dynamic-form/auto-complete/auto-complete.component';
import { RentalPracticeModel } from '@/models/rental-practice.model';
import { Registry } from '@/registry.service';
import { LoggerService } from '@services/logger.service';

@Component({
  selector: 'app-auto-complete-rental-practice',
  templateUrl: './auto-complete-rental-practice.component.html',
  styleUrls: ['../../auto-complete.component.scss'],
})
export class AutoCompleteRentalPracticeComponent extends AutoCompleteComponent {
  protected getValue(selectedOption: RentalPracticeModel): string {
    if (!selectedOption) {
      return '';
    }

    return [selectedOption.codicePratica, selectedOption.targa, selectedOption.modello]
      .filter((part) => part !== null && part !== undefined && part !== '')
      .join(' - ');
  }

  clearValue(event: MouseEvent): void {
    event.stopPropagation();
    event.preventDefault();
    this.control.setValue(null);

    const action = this.meta.clearAction;
    const target = this.meta.classToUse ? Registry.getInstance().get(this.meta.classToUse) : null;

    if (action && target && typeof target[action] === 'function') {
      target[action]();
    } else {
      LoggerService.log('No clearAction registered for autocomplete-rental-practice');
    }
  }
}
